import React from 'react';
import { IonRow,IonCol,IonItemDivider, IonText,IonIcon,IonButton } from '@ionic/react';
import { chevronForward, checkmarkDone,checkmark,warning   } from 'ionicons/icons';

const textos:any=[
    '',
    'Valorar suprimir fármacos prescindibles o situaciones que puedan estar causando hipotensión, bradicardia o deterioro de la función renal, para poder reconducir al paciente a un escenario más favorable que permita introducir el tratamiento óptimo con BB-INRA (IECAs/ARA II)-ARM-iSGLT2.',
    'Valorar suprimir fármacos prescindibles o situaciones que ºpuedan estar causando hipotensión, bradicardia o deterioro de la función renal, para poder reconducir al paciente a un escenario más favorable que permita introducir el tratamiento óptimo con BB-INRA (IECAs/ARA II)-ARM-iSGLT2.',
    'Valorar suprimir fármacos prescindibles o situaciones que puedan estar causando hipotensión, bradicardia, deterioro de la función renal o hiperpotasemia, para poder reconducir al paciente a un escenario más favorable que permita introducir el tratamiento óptimo con BB-INRA (IECAs/ARA II)-ARM-iSGLT2.',
    'Valorar suprimir fármacos prescindibles o situaciones que puedan estar causando hipotensión o bradicardia, para poder reconducir al paciente a un escenario más favorable que permita introducir el tratamiento óptimo con BB-INRA (IECAs/ARA II)-ARM-iSGLT2.',
    'Valorar suprimir fármacos prescindibles o situaciones que puedan estar causando hipotensión, bradicardia o hiperpotasemia, para poder reconducir al paciente a un escenario más favorable que permita introducir el tratamiento óptimo con BB-INRA (IECAs/ARA II)-ARM-iSGLT2.',
    'Valorar suprimir fármacos prescindibles o situaciones que puedan estar causando hipotensión o deterioro de la función renal, para poder reconducir al paciente a un escenario más favorable que permita introducir el tratamiento óptimo con BB-INRA (IECAs/ARA II)-ARM-iSGLT2.',
    'Valorar suprimir fármacos prescindibles o situaciones que puedan estar causando hipotensión o deterioro de la función renal, para poder reconducir al paciente a un escenario más favorable que permita introducir el tratamiento óptimo con BB-INRA (IECAs/ARA II)-ARM-iSGLT2.',
    'Valorar suprimir fármacos prescindibles o situaciones que puedan estar causando hipotensión, deterioro de la función renal o hiperpotasemia, para poder reconducir al paciente a un escenario más favorable que permita introducir el tratamiento óptimo con BB-INRA (IECAs/ARA II)-ARM-iSGLT2.',
    'Valorar suprimir fármacos prescindibles o situaciones que puedan estar causando hipotensión, para poder reconducir al paciente a un escenario más favorable que permita introducir el tratamiento óptimo con BB-INRA (IECAs/ARA II)-ARM-iSGLT2.',
    'Valorar suprimir fármacos prescindibles o situaciones que puedan estar causando hipotensión o hiperpotasemia, para poder reconducir al paciente a un escenario más favorable que permita introducir el tratamiento óptimo con BB-INRA (IECAs/ARA II)-ARM-iSGLT2.',
    'Valorar suprimir fármacos prescindibles o situaciones que puedan estar causando bradicardia o deterioro de la función renal, para poder reconducir al paciente a un escenario más favorable que permita introducir el tratamiento óptimo con BB-INRA (IECAs/ARA II)-ARM-iSGLT2.',
    'Valorar suprimir fármacos prescindibles o situaciones que puedan estar causando bradicardia, deterioro de la función renal o hiperpotasemia, para poder reconducir al paciente a un escenario más favorable que permita introducir el tratamiento óptimo con BB-INRA (IECAs/ARA II)-ARM-iSGLT2.',
    'Valorar suprimir fármacos prescindibles o situaciones que puedan estar causando bradicardia o deterioro de la función renal, para poder reconducir al paciente a un escenario más favorable que permita introducir el tratamiento óptimo con BB-INRA (IECAs/ARA II)-ARM-iSGLT2.',
    'Valorar suprimir fármacos prescindibles o situaciones que puedan estar causando bradicardia, deterioro de la función renal o hiperpotasemia, para poder reconducir al paciente a un escenario más favorable que permita introducir el tratamiento óptimo con BB-INRA (IECAs/ARA II)-ARM-iSGLT2.',
    'Valorar suprimir fármacos prescindibles o situaciones que puedan estar causando bradicardia, para poder reconducir al paciente a un escenario más favorable que permita introducir el tratamiento óptimo con BB-INRA (IECAs/ARA II)-ARM-iSGLT2.',
    'Valorar suprimir fármacos prescindibles o situaciones que puedan estar causando bradicardia o hiperpotasemia, para poder reconducir al paciente a un escenario más favorable que permita introducir el tratamiento óptimo con BB-INRA (IECAs/ARA II)-ARM-iSGLT2.',
    'Valorar suprimir fármacos prescindibles o situaciones que puedan estar causando deterioro de la función renal, para poder reconducir al paciente a un escenario más favorable que permita introducir el tratamiento óptimo con BB-INRA (IECAs/ARA II)-ARM-iSGLT2.',
    'Valorar suprimir fármacos prescindibles o situaciones que puedan estar causando deterioro de la función renal o hiperpotasemia, para poder reconducir al paciente a un escenario más favorable que permita introducir el tratamiento óptimo con BB-INRA (IECAs/ARA II)-ARM-iSGLT2.',
    'Valorar suprimir fármacos prescindibles o situaciones que puedan estar causando deterioro de la función renal, para poder reconducir al paciente a un escenario más favorable que permita introducir el tratamiento óptimo con BB-INRA (IECAs/ARA II)-ARM-iSGLT2.',
    'Valorar suprimir fármacos prescindibles o situaciones que puedan estar causando deterioro de la función renal o hiperpotasemia, para poder reconducir al paciente a un escenario más favorable que permita introducir el tratamiento óptimo con BB-INRA (IECAs/ARA II)-ARM-iSGLT2.',
    '',
    'Valorar suprimir fármacos prescindibles o situaciones que puedan estar causando hiperpotasemia, para poder reconducir al paciente a un escenario más favorable que permita introducir el tratamiento óptimo con BB-INRA (IECAs/ARA II)-ARM-iSGLT2.'
  

];


    let combinaciones:any={
        1:['iSGLT2_rojo'],
        2:['iSGLT2_verde','ARM_amarillo'],
        3:['iSGLT2_verde'],
        4:['iSGLT2_verde','ARM_verde'],
        5:['iSGLT2_verde'],
        6:['BB_amarillo','iSGLT2_rojo'],
        7:['iSGLT2_verde','BB_amarillo','ARM_amarillo'],
        8:['iSGLT2_verde','BB_amarillo'],
        9:['iSGLT2_verde','ARM_verde','BB_amarillo'],
        10:['iSGLT2_verde','BB_amarillo'],
        11:['IECA_ARAII_amarillo','iSGLT2_rojo'],
        12:['iSGLT2_rojo'],
        13:['iSGLT2_verde','INRA_amarillo','ARM_amarillo'],
        14:['iSGLT2_verde'],
        15:['INRA_verde','ARM_verde','iSGLT2_verde'],
        16:['iSGLT2_verde'],
        17:['BB_verde','IECA_ARAII_amarillo','iSGLT2_rojo'],
        18:['BB_verde','iSGLT2_rojo'],
        19:['BB_verde2','INRA_amarillo','iSGLT2_verde','ARM_amarillo'],
        20:['BB_verde2','iSGLT2_verde'],
        21:['INRA_verde','BB_verde2','ARM_verde','iSGLT2_verde'],
        22:['BB_verde2','iSGLT2_verde'],
      };

      let etapas_flecha:any={

        'iSGLT2_rojo':{text:"iSGLT2",text2:"",color:'red'},
        'iSGLT2_verde':{text:"iSGLT2",text2:"",color:'verde'},
        'ARM_verde':{text:"ARM",text2:"",color:'verde'},
        'ARM_amarillo':{text:"ARM",text2:"",color:'amarillo'},
        'BB_verde':{text:"BB",text2:"",color:'verde'},
        'BB_verde2':{text:"BB",text2:"",color:'verde'},
        'BB_amarillo':{text:"BB",text2:"",color:'amarillo'},
        'IECA_ARAII_verde':{text:"IECA_ARAII",text2:"",color:'verde'},
        'IECA_ARAII_amarillo':{text:"IECA_ARAII",text2:"",color:'amarillo'},
        'INRA_verde':{text:"INRA",text2:"IECA/ARAII",color:'verde'},
        'INRA_amarillo':{text:"INRA",text2:"IECA/ARAII",color:'amarillo'},
        'DIU_verde':{text:"DIU",text2:"",color:'verde'},
        'DIU_amarillo':{text:"DIU",text2:"",color:'amarillo'},

        };
      
        let etapas_alertas:any={
        'iSGLT2_rojo':['NO iniciar. Dapagliflozina se podría mantener sólo si ya lo tomaba previamente.'],
        'iSGLT2_verde':['Sólo dapagliflozina y empagliflozina. Empagliflozina iniciar con TFG>20 y dapagliflozina con TFG >25.'],
        'ARM_verde':['    '],
        'ARM_amarillo':['En TFG<30, con extrema vigilancia del nivel de K+, se podrían dar a dosis máximas de 12,5 mg/24h.'],
        'BB_verde':['Sólo bisoprolol, carvedilol, succinato de metoprolol o nebivolol en ancianos, con vigilancia de la hipotensión y ritmo cardiaco. Si la FC es > 75 lpm con dosis máxima tolerada, valorar Ivabradina 5mg/12h.'],
        'BB_verde2':['Sólo bisoprolol, carvedilol, succinato de metoprolol o nebivolol en ancianos, con vigilancia de la hipotensión y ritmo cardiaco. Si la FC es > 75 lpm con dosis máxima tolerada, valorar Ivabradina 5mg/12h.','De primera opción sólo si el paciente está en situación de euvolemia; en caso contrario  retrasar su inicio hasta conseguir la estabilidad hemodinámica'],      
        'BB_amarillo':['Sólo bisoprolol, carvedilol, succinato de metoprolol o nebivolol en ancianos, con vigilancia de la hipotensión y ritmo cardiaco. Si la FC es > 75 lpm con dosis máxima tolerada, valorar Ivabradina 5mg/12h.'],
        'IECA_ARAII_verde':['IECA: Monitorizar nivel de K+ en las primeras semanas y TFG.','ARAII: En caso de intolerancia a ARNI o IECAs.'],
        'IECA_ARAII_amarillo':['IECA: Monitorizar nivel de K+ en las primeras semanas y TFG.','ARAII: En caso de intolerancia a ARNI o IECAs.'],
        'INRA_verde':['INRA: De primera opción en FEVI<40%. Precisa ajuste de dosis y vigilancia de la hipotensión, así como monitorización del nivel de K+ y TFG (no indicado en estadio final de ERC).','IECA: Monitorizar nivel de K+ en las primeras semanas y TFG.','ARAII: En caso de intolerancia a ARNI o IECAs.'],
        'INRA_amarillo':['INRA: De primera opción en FEVI<40%. Precisa ajuste de dosis y vigilancia de la hipotensión, así como monitorización del nivel de K+ y TFG (no indicado en estadio final de ERC).','IECA: Monitorizar nivel de K+ en las primeras semanas y TFG','ARAII: En caso de intolerancia a ARNI o IECAs.'],
        'DIU_verde':[''],
        'DIU_amarillo':['Furosemida o torasemida. Sólo si se precisan para el control de la congestion, a la menor dosis necesaria, vigilando la hipotensión.']
      
      
        };

        interface ContainerProps {
            result: number;
          }
    const Resultado: React.FC<ContainerProps> = ({ result }) => {
    return (
        <>
        <IonRow key="alert0" className="mt2  mx2">
            <IonCol>
        {result && <IonText className="w100  mb1"> {textos[result]}</IonText> }
            </IonCol>        
        </IonRow>
        
        <IonRow  className="mt1 mb3 "><IonCol><IonText className=" mb2 w100">
            
        El objetivo es introducir los siguientes fármacos, según los datos del escenario clínico, en un plazo de 4 a 8 semanas.
        </IonText></IonCol></IonRow>

        <IonRow  className="mt1 mb3 "><IonCol><IonText className=" mb2 w100">
            
            Orden recomendado:</IonText></IonCol>
        </IonRow><IonRow  className="mt1 mb3 ">
        {result && combinaciones[result].map( (item:any,index:number) => (
                <IonCol size="3">
                    <IonButton color="primary"  className="f1">
                        {etapas_flecha[item].color==="red" && <IonIcon className=" pr1 rojo" icon={warning}></IonIcon>}
                        {etapas_flecha[item].color==="amarillo" && <IonIcon className=" pr1 amarillo" icon={checkmark}></IonIcon>}
                        {etapas_flecha[item].color==="verde" && <IonIcon className=" pr1  verde" icon={checkmarkDone}></IonIcon>}
                            {etapas_flecha[item].text}</IonButton>
                </IonCol>
            )) }
        </IonRow>

            {result && combinaciones[result].map( (item:any) => (
                <>
        <IonRow key={"rowtitle"+item} >
                <IonCol size="12">
            <IonText key="title" className="w100 f3 mb1 mt2">
            {etapas_flecha[item].color==="red" && <IonIcon className="f1 pr1 rojo" icon={warning}></IonIcon>}
            {etapas_flecha[item].color==="amarillo" && <IonIcon className="f1 pr1 amarillo" icon={checkmark}></IonIcon>}
            {etapas_flecha[item].color==="verde" && <IonIcon className="f1 pr1  verde" icon={checkmarkDone}></IonIcon>}

                {etapas_flecha[item].text}
            {etapas_flecha[item].text2 && <IonText className="f1 "> ({etapas_flecha[item].text2})</IonText>}
            </IonText>
            </IonCol>

        </IonRow>
        {etapas_alertas[item].map( (element:any) => <IonRow><IonCol  size="12"><IonText className="w100 f1 mb2  text-left">{element}</IonText></IonCol></IonRow> )}
        </>
        )) }
        <IonItemDivider></IonItemDivider>
            {(result>0 && result<10) && 
                <>
                <IonRow key="DIU" className="pt2">
                    <IonCol  size="12">
                        <IonText className="f1 mt2 w100" ><br/>Opcional: Solo si se precisan para el control de la congestión, a la menor dosis necesaria</IonText>
                    </IonCol>
                </IonRow>
                <IonRow key="DIU">
                    <IonCol  size="12">
                        <IonText key="title" className="w100 f3 mb1 mt2">
                            <IonIcon className="f1 pr1 amarillo" icon={checkmark}></IonIcon>
                            DIU
                        </IonText>
                        </IonCol>
                </IonRow>
                <IonRow key="DIU2">
                    <IonCol size="12">
                        <IonText className="w100 f1 mb2  text-left">Furosemida o torasemida. Sólo si se precisan para el control de la congestion, a la menor dosis necesaria, vigilando la hipotensión.</IonText>
                    </IonCol>
                </IonRow></>}
            {(result>0 && result>10) && <>
                    <IonRow>
                        <IonCol size="12">
                        <IonText className="f1 mt2 w100" ><br/>Opcional: Solo si se precisan para el control de la congestión, a la menor dosis necesaria</IonText>
                    </IonCol>
                </IonRow>
                <IonRow className="">
                <IonCol size="12"><IonText key="title" className="w100 f3 mb1 mt2"><IonIcon className="f1 pr1 verde" icon={checkmarkDone}></IonIcon>DIU</IonText></IonCol>
                </IonRow>
                </>}
                <IonItemDivider></IonItemDivider>
                <IonRow className="">
                <IonCol size="12">
                    <IonText class="f1">Leyenda: </IonText>
                    </IonCol>
                </IonRow>
                    <IonRow className="">
                <IonCol size="12">
                    <IonButton color="light" size="small"  className="f0"><IonIcon className=" pr1  verde" icon={checkmarkDone}></IonIcon> Especialmente indicado</IonButton>
                    </IonCol>
                </IonRow>
                    <IonRow className="">
                <IonCol size="12">
                    <IonButton color="light" size="small"  className="f0"><IonIcon className=" pr1 amarillo" icon={checkmark}></IonIcon> Vigilancia especial</IonButton>
                    </IonCol>
                </IonRow>
                    <IonRow className="">
                <IonCol size="12">
                    <IonButton color="light" size="small" className="f0"><IonIcon className=" pr1 rojo" icon={warning}></IonIcon> Extrema precaución</IonButton>
                    </IonCol>
                </IonRow>
                <IonRow className="">
                <IonCol size="12">
                <IonText className="f1 mt2 w100" >
                Esta web es un apoyo a las decisiones del clinico, quien conoce e individualiza el tratamiento del paciente
                </IonText>
                
                    </IonCol>
                </IonRow>


        </>
  );
};

export default Resultado;
